// extracted by mini-css-extract-plugin
export var background = "_redotech-redo-web-lib-select-dropdown-background";
export var brand = "_redotech-redo-web-lib-select-dropdown-brand";
export var check = "_redotech-redo-web-lib-select-dropdown-check";
export var container = "_redotech-redo-web-lib-select-dropdown-container";
export var dropdown = "_redotech-redo-web-lib-select-dropdown-dropdown";
export var enter = "_redotech-redo-web-lib-select-dropdown-enter";
export var exitActive = "_redotech-redo-web-lib-select-dropdown-exit-active";
export var label = "_redotech-redo-web-lib-select-dropdown-label";
export var line = "_redotech-redo-web-lib-select-dropdown-line";
export var option = "_redotech-redo-web-lib-select-dropdown-option";
export var reducedPadding = "_redotech-redo-web-lib-select-dropdown-reduced-padding";
export var select = "_redotech-redo-web-lib-select-dropdown-select";
export var selectIcon = "_redotech-redo-web-lib-select-dropdown-select-icon";